<div class="flex flex-row">
  <div [formGroup]="labelFormGroup" class="form flex flex-col">

    <nx-edit-text-input
      formControlName="scopedName"
      [helpText]="':: erstellt ein Scoped-Label, z.B. Schaden::rechts.'"
      label="Name">
    </nx-edit-text-input>

    <nx-edit-color-input
      formControlName="color"
      label="Farbe">
    </nx-edit-color-input>

    <nx-edit-text-input
      formControlName="externalId"
      label="Externe ID">
    </nx-edit-text-input>

    <nx-textfield-input
      formControlName="description"
      placeholder="Beschreibung eingeben..."
      label="Beschreibung">
    </nx-textfield-input>

  </div>

</div>
